import React from 'react';
import AddRefundCreditModal from "./AddRefundCreditModal";
import CreateRequestRefundModal from "./CreateRequestRefundModal";
import ManageRequestRefundModal from "./ManageRequestRefundModal";
import RequestPayoutOnHoldModal from './RequestPayoutOnHoldModal';
import CancelInvoiceModal from "./CancelInvoiceModal";
import MarkInvoiceAsPaidModal from './MarkInvoiceAsPaidModal';
import {InvoiceActionDialogs} from "../InvoiceActions";
import type {Invoice, InvoiceActionDialog} from "../InvoiceActions";

type InvoiceActionHandler = (callbackAction?: string, invoice?: {transactionId: string}, message?: string) => void;

interface InvoiceActionsDialogWrapperProps {
  activeDialog: InvoiceActionDialog | null;
  /** Null until an action is chosen; the modals stay mounted (closed) in the meantime. */
  invoice: Invoice | null;
  onInvoiceAction: InvoiceActionHandler;
  onClose?: InvoiceActionHandler;
}

const InvoiceActionsDialogWrapper = ({
  activeDialog,
  invoice: activeInvoice,
  onInvoiceAction,
  onClose
}: InvoiceActionsDialogWrapperProps) => {

  // The modals only read the invoice while open, which is only possible once an invoice is set.
  const invoice = activeInvoice as Invoice;

  const onDialogClose: InvoiceActionHandler = (...e) => {
    onClose && onClose(...e);
  }

  return (
    <>
      <AddRefundCreditModal open={activeDialog === InvoiceActionDialogs.ADD_REFUND_CREDIT} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <CreateRequestRefundModal open={activeDialog === InvoiceActionDialogs.CREATE_REQUEST_REFUND} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <ManageRequestRefundModal open={activeDialog === InvoiceActionDialogs.MANAGE_REQUEST_REFUND} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <CancelInvoiceModal open={activeDialog === InvoiceActionDialogs.CANCEL_INVOICE} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <RequestPayoutOnHoldModal open={activeDialog === InvoiceActionDialogs.REQUEST_PUT_PAYOUT_ON_HOLD} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
      <MarkInvoiceAsPaidModal open={activeDialog === InvoiceActionDialogs.MARK_INVOICE_AS_PAID} invoice={invoice} onInvoiceAction={onInvoiceAction} onClose={onDialogClose} />
    </>
  );
};

export default InvoiceActionsDialogWrapper;
